module.exports = __webpack_public_path__ + "static/img/unxp_footer.b7dc571a.png";